function formatCurrency(value) {
    if (!value && value !== 0) return 'R$0,00';
    return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
}

function formatDateBR(dateStr) {
    if (!dateStr) return '';
    // Accepts 'yyyy-MM-dd' or Date
    const d = typeof dateStr === 'string' ? new Date(dateStr + 'T00:00:00') : dateStr;
    return d.toLocaleDateString('pt-BR', {day: '2-digit', month: '2-digit', year: '2-digit'});
}

function buildAddress(rental) {
    const parts = [
        rental.address,
        rental.addressNumber,
        rental.addressComplement,
        rental.neighborhood,
    ].filter(Boolean);
    return parts.join(' ');
}

export function buildRentalSummaryMessage(rental, pixKey, ownerName) {
    const items = Array.isArray(rental.rentalItems) ? rental.rentalItems.filter(i => i && i.product) : [];

    // Agrupa itens por data de entrega + data de devolução do próprio item.
    const groups = [];
    const keyOf = (item) => `${item.rentalDate}|${item.returnDate}`;
    items.forEach((item) => {
        const key = keyOf(item);
        let group = groups.find((g) => g.key === key);
        if (!group) {
            group = {key, items: [], rentalDate: item.rentalDate, returnDate: item.returnDate};
            groups.push(group);
        }
        group.items.push(item);
    });

    const calcDays = (rentalDate, returnDate) => {
        if (!rentalDate || !returnDate) return '';
        const d1 = new Date(rentalDate + 'T00:00:00');
        const d2 = new Date(returnDate + 'T00:00:00');
        const diff = Math.round((d2 - d1) / (1000 * 60 * 60 * 24));
        return diff < 1 ? 1 : diff;
    };

    let itemCounter = 0;
    const itemLines = groups.map((group) => {
        const names = group.items.map((i) => `ITEM ${++itemCounter}: ${i.product?.name || ''}`).join('\n');
        const delivery = formatDateBR(group.rentalDate);
        const devolution = formatDateBR(group.returnDate);
        const days = calcDays(group.rentalDate, group.returnDate);
        return `${names}\n\nPeríodo de locação: ${days} dias\nEntrega: ${delivery}\nDevolução: ${devolution}`;
    }).join('\n\n');

    const totalValue = formatCurrency(rental.totalValue);

    const address = buildAddress(rental);
    const addressLine = address ? `\n\nEndereço de retirada/devolução: ${address}` : '';

    const pixLine = pixKey ? `Pix para pagamento${pixKey.includes('@') ? ' (email)' : ''}:\n${pixKey}` : '';
    const ownerLine = ownerName ? `\n${ownerName}` : '';

    return `Resumo do pedido

CLIENTE: ${rental.customer?.name || ''}

${itemLines}

Valor: ${totalValue}${addressLine}

Reservas para datas futuras solicitamos pagamento de pelo menos 50% do valor para garantir a disponibilidade do item na data desejada

${pixLine}${ownerLine}

*Em caso de pagamento no cartão de crédito, solicitar o link de pagamento, lembrando que terá o acréscimo do juro da maquininha (consultar valor)

A entrega será realizada após confirmação do pagamento.

Agradecemos sua locação.`;
}

export function formatWhatsAppPersonName(personName) {
    const fullName = (personName || '').trim();
    if (!fullName) {
        return '';
    }

    const firstName = fullName.split(/\s+/)[0];
    if (!firstName) {
        return '';
    }

    return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
}

export function buildDefaultWhatsAppMessage(personName) {
    const name = formatWhatsAppPersonName(personName);
    if (!name) {
        return 'Olá';
    }
    return `Olá, ${name}`;
}

export function normalizeBrazilPhone(phoneNumber) {
    if (phoneNumber === undefined || phoneNumber === null) {
        return null;
    }

    const digits = String(phoneNumber).replace(/\D/g, '');
    if (!digits) {
        return null;
    }

    if (digits.startsWith('55') && digits.length >= 12) {
        return digits;
    }

    return `55${digits}`;
}

export function buildWhatsAppUrl(phoneNumber, message) {
    const phoneOnlyNumbers = normalizeBrazilPhone(phoneNumber);
    if (!phoneOnlyNumbers) {
        return null;
    }

    let url = `https://api.whatsapp.com/send?phone=${phoneOnlyNumbers}`;
    if (message) {
        url += `&text=${encodeURIComponent(message)}`;
    }

    return url;
}

export function openWhatsAppChat(phoneNumber, message) {
    const url = buildWhatsAppUrl(phoneNumber, message);
    if (!url) {
        return false;
    }

    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
}
